import { h } from '@atomify/jsx';

export type PillColor = 'green' | 'orange' | 'red' | 'purple' | 'blue' | 'grey';

export type PillSize = 'small' | 'regular' | 'large';

export type PillFontStyle = 'label' | 'label-semi-bold';

export interface PillProps {
    element?: string;
    text?: string | Text;
    size?: PillSize;
    color?: PillColor;
    fontStyle?: PillFontStyle;
    classes?: string;
    icon?: string;
    children?: Element | Element[];
}

const Pill = ({ element = 'span', size, text, color, fontStyle = 'label', classes, children }: PillProps) => {
    const Tag = element;
    const className = {
        'c-pill': true,
        [`pill--${size ?? 'regular'}`]: true,
        [`pill--${color ?? 'blue'}`]: true,
        [`u-${fontStyle}`]: true,
        ...(classes && { [classes]: true }),
    };

    return (
        <Tag class={className}>
            {text}
            {children}
        </Tag>
    );
};

export { Pill };
